// eslint-disable-next-line import/prefer-default-export
export enum Fiability {
  LOW,
  MEDIUM,
  HIGH,
}
